<template>
  <div>
    <div class="c-wallet-with-shopping container">
      <WalletHolidayNotice
        :visibleRanges="[
          {
            start: new Date('2026-10-30T03:00:00.000Z'), // 30/10/2026 00:00
            end: new Date('2026-11-02T02:59:59.999Z'), // 01/11/2026 23:59
          },
        ]"
      />
      <div class="banner-section">
        <BannerFlexRepass />
        <WalletBannerTaxBack status="elegivel" @open-share-modal="openShareModal" />
      </div>

      <div class="columns is-gapless">
        <div class="column is-4">
          <TheBannerBonus class="is-hidden-tablet" />
          <TheWalletValuesSummary />
          <CardDepositMoney v-if="walletSummary.wallet.settings.add_credit_from_pix"
                            @open-modal-deposit-money="openModal" />
        </div>
        <div class="column is-hidden-mobile">
          <TheBannerBonus />
          <WalletLastTransactions />
        </div>
      </div>
    </div>

    <ModalDepositMoney ref="modelDepositMoney" />
    <ShareWedsiteUrlModal ref="shareModal" />
  </div>
</template>

<script>
import CardDepositMoney from '@/components/Wallet/CardDepositMoney.vue'
import TheWalletValuesSummary from '@/components/Wallet/Index/TheWalletValuesSummary.vue'
import ModalDepositMoney from '@/components/Wallet/ModalDepositMoney.vue'
import TheBannerBonus from '@/components/Wallet/WalletBannerBonus.vue'
import WalletLastTransactions from '@/components/Wallet/WalletLastTransactions.vue'
import BannerFlexRepass from '@/components/Shared/BannerFlexRepass.vue'
import WalletHolidayNotice from '@/components/Wallet/WalletHolidayNotice.vue'
import WalletBannerTaxBack from '@/components/Campaigns/WalletBannerTaxBack.vue'
import ShareWedsiteUrlModal from '@/components/Shared/ShareWedsiteUrlModal.vue'

export default {
  components: {
    TheWalletValuesSummary,
    WalletLastTransactions,
    TheBannerBonus,
    ModalDepositMoney,
    CardDepositMoney,
    WalletHolidayNotice,
    BannerFlexRepass,
    WalletBannerTaxBack,
    ShareWedsiteUrlModal
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },
  },

  methods: {
    openModal() {
      this.$refs.modelDepositMoney.open()
    },

    openShareModal() {
      this.$refs.shareModal.open()
    },
  },
}
</script>

<style lang="scss">
.bonus-bannner {
  margin: 24px 16px;
}

.layout {
  position: relative;
  background-color: $gray-1;

  @media (min-width: $mobile) {
    background-color: transparent;

    &:before {
      @include position(absolute, auto, 0, 0, 0);
      content: '';
      width: 33.3333333333%;
      height: 100%;
      z-index: -1;
      background-color: $gray-1;
    }
  }
}

.banner-section {
  width: 100% ;
  display: flex;
  justify-content: flex-end;
  align-items: center;  
  flex-direction: column;
}
</style>
